import React, { useState, useEffect } from "react";
import DashboardNavbar from "../components/DashboardNavbar.js";
import Sidebar from "../components/Sidebar.js";
import DashboardFooter from "../components/DashboardFooter.js";
import {
    Flex,
    Text,
    Button,
    Image,
    useToast
} from "@chakra-ui/react";
import { Link } from "react-router-dom"
import TeamList from "../components/TeamList";
import TeamService from "../services/team-service";

const Teams = () => {

    const toast = useToast();
    const [teams, setTeams] = useState("")

    useEffect(
        () => {
            async function getTeams() {
                try {
                    const response = await TeamService.getTeams()
                    if (response.status === 200) {
                        setTeams(response.data.teams)
                    }
                } catch (err) {
                    toast({
                        title: "Ooops!",
                        description: "Unable to get teams. Please reload page",
                        status: "error",
                        duration: 3000,
                        isClosable: true,
                    })
                }
            }
            getTeams()
        }, [toast]
    )

    return (
        <>
            <Sidebar />
            <div className="relative md:ml-64 bg-white">
                <DashboardNavbar title="Teams" hideBecomeAMentorButton={true} />
                {/* Header */}
                <div className="relative bg-white md:pt-32 pb-16"></div>
                <div className="px-4 md:px-10 mx-auto w-full -m-24">
                    <div className="flex flex-wrap mt-4">
                        <div className="w-full  mb-12 xl:mb-0 px-2">
                            <div className="relative flex flex-col min-w-0 break-words bg-white w-full mb-6 rounded">
                                <div className="rounded-t mb-0 px-2 border-0">
                                    <Flex mt={["50px", "50px", "50px", "20px"]} p={["10px", "10px", "10px", "20px"]} shadow="lg" flexDirection="column">
                                        <Flex justifyContent="space-between" direction={["column", "row"]} alignItems="center" mx="10px">
                                            <Flex alignItems="center">
                                                <Text fontSize="25px" ml="10px" color="#2d3748" fontWeight="bold" > Your Teams </Text>
                                            </Flex>
                                            <Flex>
                                                <Text fontSize="sm" ml="10px" color="#718096" fontWeight="bold" > {teams ? teams.length : "0"} Teams </Text>
                                            </Flex>
                                        </Flex>
                                        <TeamList teams={teams} />
                                        <Flex mt="20px">
                                            <Link to="/create-team" >
                                                <Button _focus={{ outline: "none" }} colorScheme="orange"> Create new team </Button>
                                            </Link>
                                        </Flex>
                                    </Flex>
                                </div>
                            </div>
                        </div>
                    </div>
                    <DashboardFooter title="Teams" />
                </div>
            </div>
        </>
    )
}

export default Teams;
